export default __webpack_public_path__ + "static/media/noa-32.65878a39.jpg";